<template>
  <v-card-text>
    <v-form v-model="valid" lazy-validation @submit.prevent="submit" ref="form">
      <v-row>
        <v-col class="py-0" md="8" cols="12">
          <v-file-input
            v-model="formData.documento"
            accept="application/pdf"
            label="Documento"
            dense
            clearable
            outlined
            show-size
            :error-messages="errors.documento"
            :rules="rules.documento"
          >
          </v-file-input>
        </v-col>
        <v-col class="py-0" md="2" cols="6">
          <v-text-field
            label="Exercício *"
            :error-messages="errors.exercicio"
            v-model.number="formData.exercicio"
            :counter="4"
            :rules="rules.exercicio"
            outlined
            dense
            class="pa-0"
          >
          </v-text-field>
        </v-col>
        <v-col class="py-0" md="2" cols="6">
          <v-btn type="submit" color="teal" dark depressed tile block>
            <v-icon left>mdi-send</v-icon>
            Enviar
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
    <VeiculoDocumentoTable />
  </v-card-text>
</template>

<script>
import toastMessage from '@/services/util/alertService';
import { required } from '@/services/util/validate';
import { mapState, mapActions } from 'vuex';
import VeiculoDocumentoTable from '@/views/private/frota/veiculo/tables/TableDocumento.vue';

export default {
  name: 'TabDocumento',
  components: { VeiculoDocumentoTable },
  data: () => ({
    valid: true,
    formData: {
      exercicio: '',
      documento: null,
    },
    formDataDefault: {
      exercicio: '',
      documento: null,
    },
    rules: {
      exercicio: [required],
      documento: [required],
    },
    errors: {
      exercicio: [],
      documento: [],
    },
    isloadingSubmit: false,
  }),
  created() {},
  computed: {
    ...mapState('veiculo', ['data']),
  },
  methods: {
    ...mapActions('veiculo', ['storeFile']),
    submit() {
      if (this.$refs.form.validate()) {
        this.isloadingSubmit = true;
        this.storeFile(this.getFormData())
          .then(() => {
            toastMessage.successSave('Upload Efetuado com sucesso.');
            this.closeDialog();
          })
          .catch(({ response }) => {
            if (response.status === 422) {
              const { errors } = response.data;
              Object.entries(errors).forEach(([index, value]) => {
                this.errors[index].push(value.toString());
                toastMessage.errorValidation();
              });
            } else {
              toastMessage.errorSave('Erro ao fazer upload de arquivo.');
            }
          })
          .finally(() => {
            this.isloadingSubmit = false;
          });
      }
    },
    resetValidation() {
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    closeDialog() {
      setTimeout(() => {
        Object.entries(this.formDataDefault).forEach(([key]) => {
          this.formData[key] = this.formDataDefault[key];
        });
        this.resetValidation();
      }, 300);
    },
    getFormData() {
      const formData = new FormData();
      formData.append('veiculo_id', this.data.id);
      Object.entries(this.formDataDefault).forEach(([key]) => {
        if (key === 'documento') {
          if (this.formData[key]) {
            formData.append(key, this.formData[key]);
          }
        } else {
          formData.append(key, this.formData[key]);
        }
      });
      return formData;
    },
  },
  watch: {
    'formData.exercicio': function () {
      this.errors.exercicio = [];
    },
    'formData.documento': function () {
      this.errors.documento = [];
    },
  },
};
</script>
